<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Stage 3
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <p>Copy the userstories defined here to the stage 3 for this full budget project.</p>


                    <c-button class="btn btn-primary" @click="convert">Convert</c-button><br/>
                    <c-button class="btn btn-primary mt-3" v-if="hasStage3" @click="updateBacklog">Update Stage 3</c-button><br/>
                    <small v-if="hasStage3">Add to the stage 3 sprint planning board any user stories that do not already exists. <br/>
                    Note it will not update existing ones.</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import { http, notify } from 'utils'
    import { LaddaButton } from 'components/form/input'
    import Multiselect from 'vue-multiselect'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton,
            Multiselect
        },

        data () {
            return {
                costing: {}
            }
        },

        computed: {
            ...mapState('yodizproject', {
                project: 'single'
            }),
            ...mapState('yodizproject/stages', {
                stage: 'single'
            }),

            hasStage3 () {
              return this.project.stages.find((item) => item.stage_id === 3)
            }
        },

        mounted () {
            http.get('/user-story-document/'+this.project.user_story_document_id+'/costing').then(
                (response) => {
                    this.costing = response.entity
            })
        },

        methods: {
            convert () {
                return http.post('/projects/'+this.$route.params.project_id+'/stages/'+this.$route.params.stage_id+'/convert', {}).then((response) => {
                    notify.success('Stage 3 Updated...')
                }).catch(() => {
                    notify.error("Looks like something went wrong")
                })
            },

            updateBacklog () {
                return http.post('/projects/'+this.$route.params.project_id+'/stages/'+this.$route.params.stage_id+'/update-backlog', {}).then((response) => {
                    notify.success('Stage 3 Updated. Created ' + response.data.created_count + ' new user stories')
                }).catch(() => {
                    notify.error("Looks like something went wrong")
                })
            }
        }
    }
</script>
